import React, { useEffect, useState } from "react";
import api from "../../utils/apiClient";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import UploadWidget from "../UploadWidget";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { notification, Spin } from "antd";
import "../../style/AdSpaceRequest.css";

const statusClassMap = {
  pending: "status-pending",
  approved: "status-approved",
  rejected: "status-rejected",
  published: "status-published",
};

function AdSpaceRequest() {
  const { authToken } = useAuth();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [duration, setDuration] = useState(7);
  const [banner, setBanner] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authToken) {
      navigate("/login");
      return;
    }
    fetchRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, navigate]);

  const fetchRequests = async () => {
    setLoading(true);
    try {
      const res = await api.get("pendingAdSpaces/mine");
      setRequests(res.data || []);
    } catch (error) {
      console.error("Error fetching requests", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!banner) {
      notification.error({ message: "Sube un banner para tu anuncio" });
      return;
    }
    setSubmitting(true);
    try {
      await api.post("pendingAdSpaces", {
        banner,
        titulo: title,
        duracionDias: Number(duration),
      });
      notification.success({ message: "Solicitud enviada" });
      setTitle("");
      setDuration(7);
      setBanner("");
      fetchRequests();
    } catch (error) {
      console.error("Error creating request", error);
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "No se pudo enviar la solicitud";
      notification.error({ message });
    } finally {
      setSubmitting(false);
    }
  };

  const handleReset = () => {
    setTitle("");
    setDuration(7);
    setBanner("");
  };

  const formatDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    return date.toLocaleDateString();
  };

  return (
    <>
      <Navbar />
      <div className="page-container">
        <div className="ad-request-card">
          <h1>Solicitar espacio publicitario</h1>
          <p>
            Envía los detalles de tu banner y selecciona el tiempo que deseas que
            esté visible en la página principal.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <label>
                Título del anuncio
                <input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Nombre interno para identificar tu anuncio"
                  required
                />
              </label>
              <label>
                Duración (días)
                <input
                  type="number"
                  min={1}
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                  required
                />
              </label>
              <div className="upload-wrapper">
                <label>Banner</label>
                <UploadWidget onUploadSuccess={setBanner} />
                {banner && (
                  <div className="banner-preview">
                    <img src={banner} alt="Banner" />
                  </div>
                )}
              </div>
            </div>
            <div className="actions">
              <button type="submit" className="primary-btn" disabled={submitting}>
                {submitting ? "Enviando..." : "Enviar solicitud"}
              </button>
              <button
                type="button"
                className="secondary-btn"
                onClick={handleReset}
                disabled={submitting}
              >
                Limpiar
              </button>
            </div>
          </form>
        </div>

        <div className="ad-request-card">
          <h2>Mis solicitudes</h2>
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "2rem" }}>
              <Spin />
            </div>
          ) : requests.length === 0 ? (
            <p>No tienes solicitudes registradas.</p>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table className="requests-table">
                <thead>
                  <tr>
                    <th>Título</th>
                    <th>Duración</th>
                    <th>Estado</th>
                    <th>Creado</th>
                    <th>Vence</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.map((req) => (
                    <tr key={req._id}>
                      <td>{req.titulo}</td>
                      <td>{req.duracionDias} día(s)</td>
                      <td>
                        <span className={`status-chip ${statusClassMap[req.status] || ""}`}>
                          {req.status}
                        </span>
                      </td>
                      <td>{formatDate(req.createdAt)}</td>
                      <td>{formatDate(req.expiresAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default AdSpaceRequest;
